import Icon from "../assets/icons";

export const MONTHS_OF_YEAR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTHS_OF_YEAR_FULL = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DAYS_OF_WEEK = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const DOB_DAYS = Array.from({ length: 31 }, (_, i) => ({
  id: i + 1,
  name: String(i + 1).padStart(2, "0"),
}));

export const DOB_YEARS = [
  { id: "", name: "Select Year" },
  ...Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => ({
    id: new Date().getFullYear() - i,
    name: String(new Date().getFullYear() - i),
  })),
];

export const COLORS = [
  "#F7AD3C",
  "#FD561F",
  "#7647EE",
  "#19AE57",
  "#EF5DA8",
  "#7879F1",
  "#55D6FF",
  "#AD91F5",
  "#E28424",
  "#65F5A9",
  "#FE9A79",
  "#C724E2",
];

export const DOCUMENT_UPLOAD_STATUS = {
  pending_approval: "pending",
  rejected: "rejected",
  approved: "approved",
};

export const PRODUCT_DEFAULT_ICONS = [
  Icon.productIcon1,
  Icon.productIcon2,
  Icon.productIcon3,
  Icon.productIcon4,
  Icon.productIcon5,
];

export const GRID_PRODUCT_DEFAULT_ICONS = [
  Icon.productAvatar1,
  Icon.productAvatar2,
  Icon.productAvatar3,
  Icon.productAvatar4,
  Icon.productAvatar5,
];

export const PERIOD = {
  ONE_MONTH: "month",
  ONE_YEAR: "year",
};

export const BOOLEAN_LABEL = {
  false: "No",
  true: "Yes",
};

export const PROPERTIES = {
  cost_price: "",
  selling_price: "",
  minimum_stock_quantity: 0,
  stock_quantity: 0,
  expiry_date: "",
  supplier_id: "",
  discount_rate: "",
  store_id: null,
  store_name: null,
};

export const PRODUCT_VARIANT = {
  option: "",
  value: "",
  barcode: "",
  store_properties: [],
};

export const DEFAULT_PRICING_ID = 1;

export const orderColor = {
  ORDER_READY: { bgColor: "#15112d", color: "#fff" },
  COMPLETED: { bgColor: "#19AE57", color: "#fff" },
  SHIPPED: { bgColor: "#F7AD3C", color: "#fff" },
  RETURNED: { bgColor: "#ff9292", color: "#fff" },
  DELIVERED: { bgColor: "#7647ee", color: "#fff" },
  SCHEDULED: { bgColor: "#F2EDFE", color: "#000" },
};

// Determines what price gets recorded on Lumi for an incoming marketplace order.
export const PRICE_RECORDING_OPTIONS = [
  {
    value: "PROVIDER_TOTAL",
    label: "Provider's total price",
    description:
      "Records the order total as sent by the provider, including delivery/service fees.",
  },
  {
    value: "ACTUAL_PRICE",
    label: "Actual item price",
    description:
      "Records only the linked items' price, excluding delivery/service fees.",
  },
  {
    value: "LUMI_PRICE",
    label: "Lumi's price for the item",
    description:
      "Records the price currently set for the linked item on Lumi Business, ignoring the provider's price.",
  },
];

export const PRICE_RECORDING_OPTION_LABELS = PRICE_RECORDING_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {},
);

// Starter questions offered on an empty Temi chat (page and docked panel);
// clicking one sends it as-is. The design system fixes the empty state at
// eight, one per supported use case, so this list is not a place to add more.
export const AI_SUGGESTED_PROMPTS = [
  "How many orders did we get last month?",
  "How many orders came in yesterday?",
  "How many orders are still pending?",
  "Which of my stores had the most orders last week?",
  "Which customers owe me money?",
  "What products are out of stock at my store?",
  "How many customers do we have?",
  "What product categories do we sell?",
];

// The docked panel is 404px wide and cannot show eight without burying the
// composer, so it offers the first few.
export const AI_SUGGESTED_PROMPTS_COMPACT = AI_SUGGESTED_PROMPTS.slice(0, 4);
